import { getPermissions } from "@/helper/collection";

export const MobileRoutes = {
  path: "/mobile",
  redirect: "/mobile/home",
  name: "Mobile Home",
  component: () => import("@/components/Containers/LandingMobile"),

  children: [
    {
      path: "home",
      name: "Mobile Home Page",
      component: () => import("@/components/Pages/HomeContainer/Home")
    },
    {
      path: "reports",
      name: "Mobile Reports",
      redirect: "reports/reports-master",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "Summary",
          name: "Report Summary",
          component: () => import("@/components/mobileDashboard/reportSummary"),
          meta: {
            permissions: getPermissions(["Analytics Manager"], false, "", 93, 1)
          }
        },
        // {
        //   path: "daily-Sales-report",
        //   name: "Mobile Daily Sales Report",
        //   component: () =>
        //     import("@/components/mobileDashboard/dailySalesReport"),
        //   meta: {
        //     permissions: getPermissions(["Analytics Manager"], false, "", 95, 1)
        //   }
        // },
        // {
        //   path: "film-Wise-report",
        //   name: "Film Wise Report",
        //   component: () =>
        //     import("@/components/mobileDashboard/filmWiseCollectionReport"),
        //   meta: {
        //     permissions: getPermissions(["Analytics Manager"], false, "", 96, 1)
        //   }
        // },
        // {
        //   path: "screen-Wise-report",
        //   name: "Screen Wise Report",
        //   component: () =>
        //     import("@/components/mobileDashboard/screenWiseCollectionReport"),
        //   meta: {
        //     permissions: getPermissions(["Analytics Manager"], false, "", 97, 1)
        //   }
        // }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/mobileRoutes.js